module.exports = __webpack_public_path__ + "static/media/help-circle.b3926f8d.png";